import axios from 'axios';

export default {
	
	

	pre_insertar(p_email, p_usuario, p_tarea, p_actividad) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.pre_InserTarea",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_tarea": p_tarea,
                    "p_actividad": p_actividad
				  })
			})
	},

	                      
	crear_tarea(p_email, p_usuario, p_codtarea, p_tarea, p_actividad, p_asistente, 
				p_feinicio, p_fevencimiento, p_fetermino, p_resultado, 
				p_poliza, p_siniestro, p_prioridad, p_observacion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.crear_tarea",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codtarea": p_codtarea,
					"p_tarea": p_tarea,
                    "p_actividad": p_actividad,
					"p_asistente": p_asistente,
					"p_feinicio": p_feinicio,
					"p_fevencimiento": p_fevencimiento,
					"p_fetermino": p_fetermino,
					"p_resultado": p_resultado,
					"p_poliza": p_poliza,
					"p_siniestro": p_siniestro,
					"p_prioridad": p_prioridad,
					"p_observacion": p_observacion
				  })
			})
	},

	recuperar_tarea(p_email, p_usuario, p_poliza, p_siniestro, p_tarea, p_actividad) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar_tarea",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_siniestro": p_siniestro,
					"p_tarea": p_tarea,
					"p_actividad": p_actividad
				  })
			})
	},

	recuperar_histtarea(p_email, p_usuario, p_poliza, p_siniestro, p_termcanc) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar_histtarea",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_siniestro": p_siniestro,
					"p_termcanc": p_termcanc
				  })
			})
	},
}